import React from 'react';
import { motion } from 'framer-motion';
import ScrollAnimation from '../ScrollAnimation';
import Carousel from './Carousel';
import { problems } from './problemsData';

export default function Problems() {
  return (
    <ScrollAnimation>
      <section className="py-12 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 stagger-item">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="inline-block relative mb-4"
            >
              <div className="bg-gradient-to-r from-primary/10 via-secondary/10 to-primary/10 text-primary px-6 py-2 rounded-full text-sm font-semibold backdrop-blur-sm border border-primary/10">
                Common Challenges
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-secondary/20 to-primary/20 blur-xl opacity-50 -z-10" />
            </motion.div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Finding these career challenges familiar?
            </h2>
          </div>

          <Carousel items={problems} />

          <div className="text-center mt-12">
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We understand, that's why we've designed our platform to address these exact pain points.
            </p>
          </div>
        </div>
      </section>
    </ScrollAnimation>
  );
}